import { DealAdvertiserDomainAPI, DealFormatAPI, DealSeatAPI, DspDealAPI } from "generated-api"
import { checkIfSessionIsOrWillExpired } from "user/tools/common"
import {
  ICreateDspDealParams,
  IDspDeal,
  IDspDealAdvertiserDomain,
  IDspDealFormat,
  IDspDealRepository,
  IDspDealSeat,
  IUpdateDspDealParams
} from "./model"

export const dspDealRPO: IDspDealRepository = {
  getAllDspDeal(campaignIds?: number[]): Promise<IDspDeal[]> {
    return new Promise<IDspDeal[]>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        DspDealAPI.getApiDspDealList(
          undefined, // offset?: number,
          undefined, // limit?: number,
          undefined, // search?: string,
          undefined, // match: 'exact' | 'contains' | 'starts_with' | 'ends_with' | 'not' = 'starts_with',
          undefined, // orderby?: Array<string>,
          undefined, // comparator?: Array<string>,
          undefined, // dealid?: Array<string>,
          undefined, // dspId?: Array<number>,
          campaignIds
        )
          .then(response => resolve(response))
          .catch(error => {
            console.error("Unexpected error while getting all dsp deals", error)
            reject("dsp-deal.get.all.error.server")
          })
      } catch (ex) {
        console.error("Unexpected error while getting all dsp deals", ex)
        reject("dsp-deal.get.all.error.unexpected")
      }
    })
  },
  createDspDeal(params: ICreateDspDealParams): Promise<IDspDeal> {
    return new Promise<IDspDeal>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        DspDealAPI.postApiDspDeal(params)
          .then(response => resolve(response))
          .catch(error => {
            console.error("Unexpected error while creating dsp deal", error)
            reject("dsp-deal.create.error.server")
          })
      } catch (ex) {
        console.error("Unexpected error while creating dsp deal", ex)
        reject("dsp-deal.create.error.unexpected")
      }
    })
  },
  updateDspDeal(params: IUpdateDspDealParams): Promise<IDspDeal> {
    return new Promise<IDspDeal>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        DspDealAPI.putApiDspDeal(params)
          .then(response => resolve(response))
          .catch(error => {
            console.error("Unexpected error while updating dsp deal", error)
            reject("dsp-deal.update.error.server")
          })
      } catch (ex) {
        console.error("Unexpected error while updating dsp deal", ex)
        reject("dsp-deal.update.error.unexpected")
      }
    })
  },
  getDspDealAdvertiserDomains(dealId: number): Promise<IDspDealAdvertiserDomain[]> {
    return new Promise<IDspDealAdvertiserDomain[]>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        DealAdvertiserDomainAPI.getApiDealAdvertiserDomainList(
          undefined, // offset?: number,
          undefined, // limit?: number,
          undefined, // search?: string,
          undefined, // match: 'exact' | 'contains' | 'starts_with' | 'ends_with' | 'not' = 'starts_with',
          undefined, // orderby?: Array<string>,
          undefined, // comparator?: Array<string>,
          undefined, // advertiserDomainId?: Array<number>,
          [dealId] // dealId?: Array<number>,
        )
          .then(response => resolve(response))
          .catch(error => {
            console.error("Unexpected error while getting dsp deal advertiser domains", error)
            reject("dsp-deal.get.advertiser-domain.error.server")
          })
      } catch (ex) {
        console.error("Unexpected error while getting dsp deal advertiser domains", ex)
        reject("dsp-deal.get.advertiser-domain.error.unexpected")
      }
    })
  },
  getDspDealFormats(dealId: number): Promise<IDspDealFormat[]> {
    return new Promise<IDspDealFormat[]>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        DealFormatAPI.getApiDealFormatList(
          undefined, // offset?: number,
          undefined, // limit?: number,
          undefined, // search?: string,
          undefined, // match: 'exact' | 'contains' | 'starts_with' | 'ends_with' | 'not' = 'starts_with',
          undefined, // orderby?: Array<string>,
          undefined, // comparator?: Array<string>,
          undefined, // formatId?: Array<number>,
          [dealId] // dealId?: Array<number>,
        )
          .then(response => resolve(response))
          .catch(error => {
            console.error("Unexpected error while getting dsp deal formats", error)
            reject("dsp-deal.get.formats.error.server")
          })
      } catch (ex) {
        console.error("Unexpected error while getting dsp deal formats", ex)
        reject("dsp-deal.get.formats.error.unexpected")
      }
    })
  },
  getDspDealSeats(dealId: number): Promise<IDspDealSeat[]> {
    return new Promise<IDspDealSeat[]>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        DealSeatAPI.getApiDealSeatList(
          undefined, // offset?: number,
          undefined, // limit?: number,
          undefined, // search?: string,
          undefined, // match: 'exact' | 'contains' | 'starts_with' | 'ends_with' | 'not' = 'starts_with',
          undefined, // orderby?: Array<string>,
          undefined, // comparator?: Array<string>,
          undefined, // seatId?: Array<number>,
          [dealId] // dealId?: Array<number>,
        )
          .then(response => resolve(response))
          .catch(error => {
            console.error("Unexpected error while getting dsp deal seats", error)
            reject("dsp-deal.get.seats.error.server")
          })
      } catch (ex) {
        console.error("Unexpected error while getting dsp deal seats", ex)
        reject("dsp-deal.get.seats.error.unexpected")
      }
    })
  },
  setDspDealAdvertiserDomains(dealId: number, advertiser_domain_ids: number[]): Promise<IDspDealAdvertiserDomain[]> {
    return new Promise<IDspDealAdvertiserDomain[]>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        DspDealAPI.putApiDspDealAdvertiserDomains(dealId, { advertiser_domain_ids })
          .then(response => resolve(response))
          .catch(error => {
            console.error("Unexpected error while setting dsp deal advertiser domains", error)
            reject("dsp-deal.set.advertiser-domain.error.server")
          })
      } catch (ex) {
        console.error("Unexpected error while setting dsp deal advertiser domains", ex)
        reject("dsp-deal.set.advertiser-domain.error.unexpected")
      }
    })
  },
  setDspDealFormats(dealId: number, format_ids: number[]): Promise<IDspDealFormat[]> {
    return new Promise<IDspDealFormat[]>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        DspDealAPI.putApiDspDealFormats(dealId, { format_ids })
          .then(response => resolve(response))
          .catch(error => {
            console.error("Unexpected error while setting dsp deal formats", error)
            reject("dsp-deal.set.format.error.server")
          })
      } catch (ex) {
        console.error("Unexpected error while setting dsp deal formats", ex)
        reject("dsp-deal.set.format.error.unexpected")
      }
    })
  },
  setDspDealSeats(dealId: number, seat_ids: number[]): Promise<IDspDealSeat[]> {
    return new Promise<IDspDealSeat[]>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        DspDealAPI.putApiDspDealSeats(dealId, { seat_ids })
          .then(response => resolve(response))
          .catch(error => {
            console.error("Unexpected error while setting dsp deal seat", error)
            reject("dsp-deal.set.seat.error.server")
          })
      } catch (ex) {
        console.error("Unexpected error while setting dsp deal seat", ex)
        reject("dsp-deal.set.seat.error.unexpected")
      }
    })
  }
}
